
import Footer from '../components/Footer/Footer';
import React, { useEffect, useCallback, createContext, useState } from 'react';
import Header from '../components/Header/Header';
import { useAuthContext, AuthContainer } from '../auth';
import FeedbackSystem from '../views/Home/FeedbackSystem';
import { usePatientData } from '../hooks/usePatientData';

export const LoginContext = createContext();

function getStoredPatientId() {
  try {
    const obj = JSON.parse(localStorage.getItem('loginObj') || '{}');
    return obj?.code || null;
  } catch {
    return null;
  }
}

const MainLayout = ({ children }) => {
  const { openAuth, closeAuth } = useAuthContext();
  const [patientId, setPatientId] = useState(getStoredPatientId);
  usePatientData(); // triggers URL ?id= auto-login on every route including home

  const openLogin = useCallback(() => openAuth('login'), [openAuth]);
  const closeLogin = useCallback(() => closeAuth(), [closeAuth]);

  useEffect(() => {
    window.openLoginModal = openLogin;
    window.closeLoginModal = closeLogin;
    return () => {
      delete window.openLoginModal;
      delete window.closeLoginModal;
    };
  }, [openLogin, closeLogin]);

  useEffect(() => {
    const onLogin = () => setPatientId(getStoredPatientId());
    const onLogout = () => setPatientId(null);
    const onStorage = (e) => { if (e.key === 'loginObj') setPatientId(getStoredPatientId()); };
    window.addEventListener('loginComplete', onLogin);
    window.addEventListener('logoutComplete', onLogout);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('loginComplete', onLogin);
      window.removeEventListener('logoutComplete', onLogout);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return (
   <LoginContext.Provider value={{ openLogin, closeLogin }}>
      <Header onLoginClick={openLogin} />
      <main>{children}</main>
      <AuthContainer />
      {patientId && <FeedbackSystem patientId={patientId} />}
      <Footer />
   </LoginContext.Provider>
  );
};

export default MainLayout;
